// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Déplacé ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Action ' + p['label'] + ' terminée',
  accButtonProgressStatus: (p: { label: string }) => 'Action ' + p['label'] + ' en cours',
  accColorPalette: () => 'Palette de couleurs',
  accColorSwatch: () => 'Échantillon de couleur',
  accCommandKey: () => 'Commande',
  accContextMenuLabel: () => 'actions',
  accControlKey: () => 'Fermer',
  accPositionAfter: () => 'après',
  accPositionBefore: () => 'avant',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Appuyez sur les touches ' +
    p['keyPressed'] +
    ' et Maj et maintenez-les, puis utilisez les touches fléchées pour reclasser les éléments.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Entrez une date complète avec ce format : ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Entrez un mois et une année avec ce format : ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Étiquette',
  chart_labelGroup: () => 'Groupe',
  chart_labelSeries: () => 'Série',
  chart_labelValue: () => 'Valeur',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  checkbox_helpForCheckbox: () => 'Aide pour la case à cocher',
  checkbox_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  checkbox_selected: () => 'Case cochée',
  checkbox_unselected: () => 'Case non cochée',
  close: () => 'Fermer',
  collection_apply: () => 'Appliquer',
  collection_cancel: () => 'Annuler',
  collection_loaded: () => 'Chargé',
  collection_loading: () => 'Chargement',
  collection_noData: () => 'Aucune donnée à afficher.',
  collection_pixels: () => 'pixels',
  collection_resizeColumnDialog: () => 'Redimensionner la colonne',
  collection_resizeColumnMenu: () => 'Redimensionner la colonne...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Entrez un nombre compris entre ' + p['MIN'] + ' et ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Sélectionner toutes les rangées',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Sélectionner la rangée ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Ordre croissant',
  collection_sortColumnMenu: () => 'Trier la colonne',
  collection_sortDescendingSubMenu: () => 'Ordre décroissant',
  collection_sortDisabled: () => 'Ne peut pas être trié',
  collection_sortEnabled: () => 'Peut être trié',
  collection_width: () => 'Largeur',
  colorPicker_label: () => 'Sélecteur de couleur',
  confirmation: () => 'Confirmation',
  datePicker_currentDate: () => 'Date courante',
  datePicker_goToToday: () => "Aller à Aujourd'hui",
  datePicker_label: () => 'Sélectionneur de date',
  datePicker_month: () => 'Mois',
  datePicker_months: () => 'Mois',
  datePicker_next: () => 'Suivant',
  datePicker_nextDecade: () => 'Décennie suivante',
  datePicker_nextMonth: () => 'Mois suivant',
  datePicker_prev: () => 'Précédent',
  datePicker_prevDecade: () => 'Décennie précédente',
  datePicker_prevMonth: () => 'Mois précédent',
  datePicker_restricted: () => 'Restreint',
  datePicker_selected: () => 'Sélectionné',
  datePicker_today: () => "Aujourd'hui",
  datePicker_weekNum: (p: { NUM: string }) => 'Semaine ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Numéro de semaine',
  datePicker_year: () => 'Année',
  datePicker_years: () => 'Années',
  diagram_promotedLink: () => '1 lien',
  diagram_promotedLinkAriaDesc: () => 'Indirect',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' liens',
  error: () => 'Erreur',
  expandableList_expandCollapseInstructionText: () =>
    "Utilisez les touches fléchées pour réduire ou étendre l'affichage",
  expandableList_groupCollapse: () => 'Réduit',
  expandableList_groupExpand: () => 'Étendu',
  filePicker_addFiles: () => 'Ajouter des fichiers',
  filePicker_dropzonePrimaryText: () => 'Glisser-déposer',
  filePicker_dropzoneSecondaryText: () => 'Sélectionner un fichier ou déposer un fichier ici',
  filePicker_dropzoneSecondaryTextMultiple: () =>
    'Sélectionner des fichiers ou déposer des fichiers ici',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Vous ne pouvez pas charger des fichiers ayant les types suivants : ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Charger un fichier à la fois',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Vous ne pouvez pas charger des fichier de type ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'inconnu',
  formControl_clear: () => 'Effacer',
  formControl_day: () => 'Jour',
  formControl_empty_segment: () => 'Vide',
  formControl_helpAvailable: () => 'Aide disponible',
  formControl_hide: () => 'Masquer',
  formControl_hour: () => 'Heure',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Vous avez atteint la limite de ' +
    ((
      {
        one: new Intl.NumberFormat('fr-CA').format(p['CHARACTER_LIMIT']) + ' caractère',
        many: new Intl.NumberFormat('fr-CA').format(p['CHARACTER_LIMIT']) + ' caractères'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('fr-CA').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('fr-CA').format(p['CHARACTER_LIMIT']) + ' caractères') +
    '.',
  formControl_loading: () => 'Chargement',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    "Vous pouvez entrer jusqu'à " + p['MAX_LENGTH'] + ' caractères.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Longueur maximale ' + p['MAX_LENGTH'] + ' dépassée.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractères restants.',
  formControl_millisecond: () => 'Milliseconde',
  formControl_minute: () => 'Minute',
  formControl_month: () => 'Mois',
  formControl_readOnly: () => 'Lecture seule',
  formControl_requiredMessageDetail: () => 'Entrez une valeur.',
  formControl_second: () => 'Seconde',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Sélectionnez ' + p['n'] + ' valeurs.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Vous avez atteint la limite de ' + p['max'] + ' sélections.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Sélectionnez entre ' + p['min'] + ' et ' + p['max'] + ' valeurs.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Sélectionnez au moins ' + p['min'] + ' valeurs.',
  formControl_show: () => 'Afficher',
  formControl_year: () => 'Année',
  gantt_labelDate: () => 'Date',
  gantt_labelEnd: () => 'Fin',
  gantt_labelLabel: () => 'Étiquette',
  gantt_labelRow: () => 'Rangée',
  gantt_labelStart: () => 'Début',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Aucune section correspondante trouvée.',
  indexer_keyboardInstructionText: () => 'Appuyez sur Entrée pour sélectionner la valeur.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Entre ' + p['FROM_SECTION'] + ' et ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Touchez deux fois et maintenez pour passer en mode geste, puis glissez vers le haut ou le bas pour ajuster la valeur.',
  info: () => 'Infos',
  inputColor_selectColor: () => 'Sélectionner une couleur',
  inputDateMask_date_cleared: () => "Date d'effacement",
  inputDateMask_dayPlaceholder: () => 'jj',
  inputDateMask_empty_segment: () => 'Vide',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Entrez une date identique ou antérieure au ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Entrez une date identique ou postérieure au ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Entrez une date disponible.',
  inputDatePicker_instruction: () =>
    'Appuyez sur la touche de tabulation pour accéder au calendrier.',
  inputDatePicker_selectDate: () => 'Sélectionner une date',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Entrez un mois et une année antérieurs ou correspondant au ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Entrez un mois et une année postérieurs ou correspondant au' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Entrez un nombre.',
  inputNumber_decrease: () => 'Réduire',
  inputNumber_increase: () => 'Augmenter',
  inputPassword_hidden: () => 'Mot de passe masqué',
  inputPassword_hide: () => 'Masquer le mot de passe',
  inputPassword_show: () => 'Afficher le mot passe',
  inputSensitiveText_hidden: () => 'Texte sensible masqué',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Entrez une heure égale à ' + p['max'] + ' ou une valeur supérieure.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Entrez une heure égale à ' + p['min'] + ' ou une valeur supérieure.',
  inputTimeMask_time_cleared: () => "Heure d'effacement",
  labelNone: () => 'Aucun',
  list_msgFetchCompleted: () => 'Chargé',
  list_msgFetchingData: () => 'Chargement',
  list_suggestion: () => 'Suggestion',
  menu_stateLoading: () => 'Chargement',
  messageToast_allMessagesClosed: () => 'Tous les avis Toast sont fermés.',
  message_close: () => 'Fermer',
  message_confirmation: () => 'Réussite',
  message_error: () => 'Erreur',
  message_info: () => 'Infos',
  message_navigationFromMessagesRegion: () =>
    'Entrée dans la région des messages. Appuyez sur F6 pour naviguer.',
  message_navigationToMessagesRegion: () =>
    'La région des messages contient des nouveaux messages. Appuyez sur F6 pour y accéder.',
  message_navigationToTouch: () => 'La région des messages contient des nouveaux messages.',
  message_warning: () => 'Avertissement',
  noData_message: () => 'Aucun élément à afficher',
  overflowItemLabel: () => 'Onglets supplémentaires',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Touchez deux fois pour fermer la fenêtre contextuelle ouverte.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Entrée dans la fenêtre contextuelle. Appuyez sur F6 pour naviguer entre la fenêtre et le contrôle associé.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Fenêtre contextuelle ouverte. Appuyez sur F6 pour naviguer entre la fenêtre et le contrôle associé.',
  progressIndeterminate: () => 'En cours',
  radioButton_checked: () => 'Bouton radio coché',
  radioButton_selected: () => 'Bouton radio sélectionné',
  radioButton_unchecked: () => 'Bouton radio non coché',
  radioButton_unselected: () => 'Bouton radio non sélectionné',
  radio_helpForRadio: () => 'Aide pour le bouton radio',
  radio_requiredMessageDetail: () => 'Sélectionnez une valeur.',
  selectMultiple_apply: () => 'Appliquer',
  selectMultiple_back: () => 'Précédent',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Utilisez les flèches vers la gauche et vers la droite pour mettre en surbrillance les valeurs sélectionnées.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Appuyez sur la touche de retour arrière ou sur la touche de suppression pour supprimer la valeur sélectionnée.',
  selectMultiple_selectedValues: () => 'Valeurs sélectionnées',
  selectMultiple_showSelectedValues: () => 'Afficher les valeurs sélectionnées uniquement.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valeurs sélectionnées.',
  select_addToList: () => 'Ajouter à la liste',
  select_addToListAvailable: () => 'Ajouter à la liste disponible',
  select_closeDropdown: () => 'Appuyez sur Échap pour fermer.',
  select_moreSearchOptions: () => 'Autres options de recherche',
  select_moreSearchOptionsAvailable: () => 'Autres options de recherche disponibles',
  select_noMatchesFound: () => "Aucune correspondance n'a été trouvée.",
  select_oneMatchFound: () => 'Une correspondance a été trouvée',
  select_requiredMessageDetail: () => 'Sélectionner une valeur.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances trouvées',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' correspondances ou plus trouvées',
  selectorAll_deselectAll: () => 'Tout désélectionner',
  selectorAll_selectAll: () => 'Tout sélectionner',
  selector_selected: () => 'Case cochée',
  selector_unselected: () => 'Case non cochée',
  sheet_close: () => 'Fermer',
  switch_off: () => 'Désactiver',
  switch_on: () => 'Activé',
  tabBarNavigationList_removeCueText: () => 'Supprimable',
  tabBar_tabContainsErrors: () => 'Contient des erreurs',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => p['itemKey'] + ' supprimé',
  tabbar_labelContextMenu: () => 'a un menu contextuel',
  tabbar_labelMoveLeft: () => 'Déplacer vers la gauche',
  tabbar_labelMoveRight: () => 'Déplacer vers la droite',
  tabbar_labelRemove: () => 'Supprimer',
  timeComponent_tooltipZoomIn: () => 'Zoom avant',
  timeComponent_tooltipZoomOut: () => 'Zoom arrière',
  timeConverter_parseError: () => 'Entrez une heure de fin.',
  train_current: () => 'Courante',
  train_message_type: () => 'Type de message',
  train_not_visited: () => 'Non visitée',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Étape ' + p['currentStep'] + ' de ' + p['numberOfSteps'],
  train_visited: () => 'Visitée',
  userAssistance_learnMore: () => 'En savoir plus',
  userAssistance_required: () => 'Obligatoire',
  vis_clearSelection: () => 'Effacer la sélection',
  vis_drillable: () => 'Forage possible',
  vis_invalidData: () => 'Données non valides',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' de ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Sélection par rectangle de sélection',
  vis_marqueeZoomTooltip: () => 'Zoom par rectangle de sélection',
  vis_noData: () => 'Aucune donnée à afficher',
  vis_panTooltip: () => 'Panoramique',
  vis_stateCollapsed: () => 'Réduit',
  vis_stateExpanded: () => 'Étendu',
  vis_stateLoaded: () => 'Chargé',
  vis_stateLoading: () => 'Chargement',
  vis_stateSelected: () => 'Sélectionné',
  vis_stateUnselected: () => 'Non sélectionné',
  warn: () => 'Avertissement'
};
export default bundle;
